import { safeScrollTo } from "@faire/retailer-visitor-shared/lib/safeScrollTo";
import { getDocumentOrThrow } from "@faire/web/common/globals/getDocument";

/**
 * Scrolls to a section smoothly
 *
 * @param sectionId The ID of the section to scroll to.
 * @param headerHeight The height of the header if you want to include in the offset calculation; specially useful in mobile where the header hides on scrolling
 */
export const goToSmoothly = (sectionId: string, headerHeight: number = 0) => {
  const targetElement = getDocumentOrThrow().getElementById(sectionId);
  const targetPosition = targetElement
    ? targetElement.offsetTop + headerHeight
    : 0;
  safeScrollTo({ left: 0, top: targetPosition, behavior: "smooth" });
};
